<template>
    <b-media vertical-align="center">
        <template #aside>
            <b-avatar
              size="32"
              :src="user.avatar"
              :text="avatarText(user.full_name)"
              variant="light-primary"
              :to="{ name: 'users-user-view', params: { id: user.id } }"
            />
        </template>
        <b-link
            :to="{ name: 'users-user-view', params: { id: user.id } }"
            class="font-weight-bold d-block text-nowrap"
        >
            {{ user.full_name }}
        </b-link>
      <small class="text-muted">{{ user.username }}</small>
    </b-media>
</template>

<script>

    import {BLink, BMedia, BAvatar} from 'bootstrap-vue'
    import { avatarText } from '@core/utils/filter'

    export default {

        components: {
            BLink, BMedia, BAvatar
        },

        props: {
            user: {
                type: Object,
                required: true
            }
        },

        setup() {
            return {
               avatarText
            }
        }

    }

</script>
